import React, {useState, useEffect} from "react";
import { PageProperties } from "./../../Model/Model"

const MyPagination = (props: PageProperties) => {
    const [pageSize, setPageSize] = useState<number>(10)
    const getPages = (currentPage: number) =>{
        let pgs: number[] = []
        if(props.totalCount && props.totalCount > 0)
        {
            let totalCount: number = props.totalCount
            let pageCount = totalCount / pageSize + (totalCount % pageSize === 0 ? 0 : 1)
            for(let i = 1; i<= pageCount; i++)
            {
                pgs.push(i)
            }
            return pgs
        }
        else
        {
            return []
        }
    }

const onPageSizeChange = (e: any) =>{
    let size = e.target.value
    setPageSize(size)
    props.onPageSizeChange(size)
}

return (getPages(props.currentPage) && 
    <div className="pagesDiv">
        <div className="pageSizeDiv">
            <select onChange={(e) => onPageSizeChange(e)}>
                <option>10</option>
                <option>20</option>
                <option>100</option>
            </select>
        </div>
        <div className="myPage">
            {props.currentPage > 1 && <li onClick={() => props.onClick(props.currentPage - 1)}>&lt;</li>}
            {(getPages(props.currentPage)).map((p, index) => {
                if(p === 1 || p === (props.totalCount || 0) / pageSize + ((props.totalCount || 0) % pageSize === 0 ? 0 : 1))
                {
                    return <li key={index} className={props.currentPage === p ? "current" : ""} 
                        onClick={() => props.onClick(p)}><span>{p.toString()}</span></li>
                } 

                if(Math.abs(p - props.currentPage) > 3)
                {
                    if(!(Math.abs(p - 1 - props.currentPage) > 3 && p - 1 !== 1))
                    {
                        return <li key={index}><span>...</span></li>
                    }
                }
                else{
                    return <li key={index} className={props.currentPage === p ? "current" : ""} 
                        onClick={() => props.onClick(p)}><span>{p.toString()}</span></li>
                }
            })}
            {props.currentPage < (getPages(props.currentPage).length) && <li onClick={() => props.onClick(props.currentPage + 1)}>&gt;</li>}
        </div>
    </div>)
}

export default MyPagination